// src/components/Header.js
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MenuIcon from "@mui/icons-material/Menu";

const Header = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser && !user) {
      window.location.reload();
    }
  }, [user]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (callback) => {
    handleClose();
    if (callback) callback();
  };

  return (
    <AppBar
      position="fixed"
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        minHeight: "64px", // Feste Mindesthöhe
        maxHeight: "64px", // Maximale Höhe
        backgroundColor: "#04182d", // Navbar-Hintergrundfarbe
        backgroundImage: "none", // Gradient entfernen
      }}
    >
      <Container 
        maxWidth="xl"
        sx={{
          paddingLeft: "0 !important",
          paddingRight: "0 !important",
          "@media (min-width: 600px)": {
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
          },
        }}
      >
        <Toolbar 
          disableGutters
          sx={{
            minHeight: "64px !important", // Feste Toolbar-Höhe
            maxHeight: "64px !important",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          {/* Logo - Links */}
          <Box
            component={RouterLink}
            to="/"
            sx={{
              textDecoration: "none",
              color: "inherit",
              flexGrow: 0,
              display: "flex",
              alignItems: "center",
              height: "64px", // Feste Höhe
              overflow: "hidden", // Verhindert, dass das Logo die Navbar vergrößert
            }}
          >
            <img
              src="/EHC_logo.svg"
              alt="EHC Kundl Logo"
              style={{
                height: "56px", // Logo-Größe, die in die 64px Navbar passt (mit etwas Padding)
                width: "auto", // Breite automatisch anpassen
                marginRight: "10px",
                objectFit: "contain", // Logo proportional skalieren
              }}
            />
          </Box>

          {/* Spacer - nimmt den Platz ein, der vorher für Zeit/Benutzer verwendet wurde */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Navigation - Rechts */}
          {user ? (
            isMobile ? (
              // Mobile Menu for logged-in users
              <Box sx={{ flexGrow: 0 }}>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleMenu}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    sx: {
                      backgroundColor: "#04182d",
                      color: "#ffffff",
                    },
                  }}
                >
                  <MenuItem
                    component={RouterLink}
                    to="/"
                    onClick={handleClose}
                  >
                    Dashboard
                  </MenuItem>

                  <MenuItem
                    component={RouterLink}
                    to="/info"
                    onClick={handleClose}
                  >
                    Info
                  </MenuItem>

                  <MenuItem
                    component={RouterLink}
                    to="/my-bids"
                    onClick={handleClose}
                  >
                    Meine Gebote
                  </MenuItem>

                  {user?.isAdmin && (
                    <MenuItem
                      component={RouterLink}
                      to="/admin"
                      onClick={handleClose}
                    >
                      Admin
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => handleMenuItemClick(logout)}
                    sx={{ color: "error.main" }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            ) : (
              // Desktop navigation for logged-in users
              <Box sx={{ flexGrow: 0, display: "flex", gap: 1 }}>
                <Button color="secondary" component={RouterLink} to="/info">
                  Info
                </Button>
                <Button color="secondary" component={RouterLink} to="/my-bids">
                  Meine Gebote
                </Button>
                {user?.isAdmin && (
                  <Button color="inherit" component={RouterLink} to="/admin">
                    Admin
                  </Button>
                )}
                <Button color="error" onClick={logout}>
                  Logout
                </Button>
              </Box>
            )
          ) : (
            // Login button for non-logged-in users (both mobile and desktop)

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button color="secondary" component={RouterLink} to="/info">
                Info
              </Button>
              <Button color="secondary" component={RouterLink} to="/login">
                Login
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
